import { render } from "./Endorsements.vue?vue&type=template&id=6bbcedf8"
import script from "./Endorsements.vue?vue&type=script&lang=js"
export * from "./Endorsements.vue?vue&type=script&lang=js"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__